import {
    clienteApiHttp,
    FetcherFunction,
    FetcherRequest,
    TokenStorage as TokenStorageBase,
} from './clienteApi';

async function fetchOrFail({ method, url, headers, body }: FetcherRequest) {
    try {
        return await window.fetch(url, { method, headers, body });
    } catch (error) {
        error.origen = 'fetch';
        throw error;
    }
}

const fetcher: FetcherFunction = async request => {
    const res = await fetchOrFail(request);

    return {
        statusCode: res.status,
        headers: res.headers,
        body: await res.text(),
    };
};

interface TokenStorage extends TokenStorageBase {
    set(token: string): void;
    clear(): void;
}

export const tokenStorage: TokenStorage = {
    set(token) {
        window.sessionStorage.setItem('token', token);
    },
    clear() {
        window.sessionStorage.removeItem('token');
    },
    get() {
        return window.sessionStorage.getItem('token');
    },
};

export const clienteApi = clienteApiHttp({
    baseUrl: '', // CRA se hará cargo de esta parte durante la construcción
    fetcher,
    tokenStorage,
});

export { ClienteApi, ErrorApi, ErrorHttp, ErrorTipoRespuesta } from './clienteApi';



// WEBPACK FOOTER //
// ./src/api/api.ts